export function TimelineConnector() {
  return (
    <div className="absolute w-0 border-l-[1px] border-dashed border-new-company-gray-500 opacity-70 top-5 bottom-[160px] left-[154px] z-1" />
  )
}
